import axios from 'axios';

class Server {
  constructor(props) {
    this.onStartLoading = null;
    this.onStopLoading = null;
    this.onError = null;
    //this.serverURI = 'http://192.168.1.16:10001';
    this.serverURI = 'https://jmarroyave-search-backend.herokuapp.com';
    this.debug = (!props || props.debug) ? false : false;
  }

  triggerOnStartLoading(){   
    if(this.onStartLoading){
      this.onStartLoading();
    }
  }

  triggerOnStopLoading(){
    if(this.onStopLoading)
      this.onStopLoading();
  }

  triggerOnError(err){
    if(this.onError)
      this.onError(err);   
  }

  exec(method, uri, params, config, callback, callback_err){
    var $this = this;   
    var url = this.serverURI + uri;
    var p;
    this.triggerOnStartLoading()
    const timeout = 60 * 1000;

    if(method === 'get'){
      p = axios.get(url, {
        params:params,
        timeout: (config && config.timeout) ? config.timeout : timeout,
      });
    } else {
      p = axios.post(url, params, {
        timeout: (config && config.timeout) ? config.timeout : timeout,
      });
    }

    if($this.debug){
      console.log("DEBUG", method.toUpperCase(), uri, params);
    }


    p.then(response => {
      if($this.debug){
        console.log("DEBUG", method.toUpperCase(), uri, params, 'Response', response);
      }
      if(callback)
        callback(response.data);
      $this.triggerOnStopLoading()
    })
    .catch(err => {
      if($this.debug){
        console.log("DEBUG", method.toUpperCase(), uri, params, "ERROR", err);
      }
      this.triggerOnError(err);
      if(callback_err){
        callback_err(err)
      }
      $this.triggerOnStopLoading()
    });      
  }

  get(uri, params, callback){
    if(params.params)
      params = params.params;
    this.exec('get', uri, params, {}, callback);
  }

  getLong(uri, params, timeout, callback, callback_err){
    if(params.params)
      params = params.params;
    this.exec('get', uri, params, {timeout: timeout}, callback, callback_err);
  }

  post(uri, params, callback, callback_err){
    if(params.params)
      params = params.params;
    this.exec('post', uri, params, {}, callback, callback_err);
  }  

  fetch(url, params, callback, callback_err){
    if(params.params)
      params = params.params;
    var $this = this;   
    this.triggerOnStartLoading()
    axios.get(url, {params:params})
    .then(function(response){
      if($this.debug){
        console.log("DEBUG", 'FETCH:', url, params, 'Server Response:', response);
      }
      if(callback){
        callback(response.data);
      }
      $this.triggerOnStopLoading()
    })
    .catch(err => {
      if($this.debug){
        console.log("DEBUG", 'FETCH:', url, params, 'Server Error:', err);
      }
      $this.triggerOnStopLoading()
      this.triggerOnError(err);
    });      
  }
}

export default Server;



// WEBPACK FOOTER //
// ./src/core/components/server.js